export default __webpack_public_path__ + "img/94357da7c38af098af429641a98ce8eb.png";